export default "__VITE_ASSET__cs3SW5fB__"